import { lazy } from 'react';

export const WorkOrdersList = lazy(() => import('./pages/WorkOrdersList'));
export const WorkOrderDetail = lazy(() => import('./pages/WorkOrderDetail'));

export { WORK_ORDER_ROUTES } from './paths';
